// extracted by mini-css-extract-plugin
module.exports = {"rightSidebarWrapper":"rightSidebarWrapper__DBpVudgP7fRP"};